import { Component, OnInit, AfterViewInit, Inject } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { CookieService } from 'ngx-cookie-service';
import { LanguageService } from '../../core/services/language.service';

import { EventService } from '../../core/services/event.service';
import { AuthenticationService } from '../../core/services/auth.service';
import { AuthfakeauthenticationService } from '../../core/services/authfake.service';
import { CmsService } from '../../core/services/cms.service';

import { DOCUMENT } from '@angular/common';

import { MENU } from './menu';
import { MenuItem } from './menu.model';
import { environment } from '../../../environments/environment';

@Component({
  selector: 'app-horizontaltopbar',
  templateUrl: './horizontaltopbar.component.html',
  styleUrls: ['./horizontaltopbar.component.scss']
})

/**
 * Horizontal Topbar and navbar specified
 */
export class HorizontaltopbarComponent implements OnInit, AfterViewInit {

  element;
  cookieValue;
  flagvalue;
  countryName;
  valueset;
  companyLogoUrl = '';

  menuItems = [];

  listLang = [
    { text: 'English', flag: 'assets/images/flags/us.jpg', lang: 'en' },
    { text: 'Spanish', flag: 'assets/images/flags/spain.jpg', lang: 'es' },
    { text: 'German', flag: 'assets/images/flags/germany.jpg', lang: 'de' },
    { text: 'Italian', flag: 'assets/images/flags/italy.jpg', lang: 'it' },
    { text: 'Russian', flag: 'assets/images/flags/russia.jpg', lang: 'ru' },
  ];

  // tslint:disable-next-line: max-line-length
  constructor(@Inject(DOCUMENT) private document: any, private router: Router, private eventService: EventService, private authService: AuthenticationService,
    private authFackservice: AuthfakeauthenticationService,
    public languageService: LanguageService,
    private cmsService: CmsService,
    // tslint:disable-next-line: variable-name
    public _cookiesService: CookieService) {
    router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        this.activateMenu();
      }
    });
  }

  ngOnInit(): void {
    this.element = document.documentElement;

    this.initialize();
    this.loadCompanyBranding();

    this.cookieValue = this._cookiesService.get('lang');
    const val = this.listLang.filter(x => x.lang === this.cookieValue);
    this.countryName = val.map(element => element.text);
    if (val.length === 0) {
      if (this.flagvalue === undefined) { this.valueset = 'assets/images/flags/us.jpg'; }
    } else {
      this.flagvalue = val.map(element => element.flag);
    }
  }

  setLanguage(text: string, lang: string, flag: string) {
    this.countryName = text;
    this.flagvalue = flag;
    this.cookieValue = lang;
    this.languageService.setLanguage(lang);
  }

  /**
   * Logout the user
   */
  logout() {
    if (environment.defaultauth === 'firebase') {
      this.authService.logout();
    } else {
      this.authFackservice.logout();
    }
    this.router.navigate(['/account/login']);
  }

  getCompanyLogo(): string {
    return this.companyLogoUrl || 'assets/images/logo-light.png';
  }

  private loadCompanyBranding(): void {
    this.cmsService.getAuthPageConfig().subscribe(
      (res: any) => {
        if (res?.isError) {
          this.companyLogoUrl = '';
          return;
        }
        this.companyLogoUrl = res?.data?.companyLogoUrl || '';
      },
      () => {
        this.companyLogoUrl = '';
      }
    );
  }

  /**
   * On menu click
   */
  onMenuClick(event) {
    const nextEl = event.target.nextElementSibling;
    if (nextEl) {
      const parentEl = event.target.parentNode;
      if (parentEl) {
        parentEl.classList.remove("show");
      }
      nextEl.classList.toggle("show");
    }
    return false;
  }

  ngAfterViewInit() {
    this.activateMenu();
  }

  /**
   * remove active and mm-active class
   */
  _removeAllClass(className) {
    const els = document.getElementsByClassName(className);
    while (els[0]) {
      els[0].classList.remove(className);
    }
  }

  /**
   * Togglemenu bar
   */
  toggleMenubar() {
    const element = document.getElementById('topnav-menu-content');
    element.classList.toggle('show');
  }

  /**
   * Activates the menu
   */
  private activateMenu() {

    const resetParent = (el: any) => {
      const parent = el.parentElement;
      if (parent) {
        parent.classList.remove('active');
        const parent2 = parent.parentElement;
        this._removeAllClass('mm-active');
        this._removeAllClass('mm-show');
        if (parent2) {
          parent2.classList.remove('active');
          const parent3 = parent2.parentElement;
          if (parent3) {
            parent3.classList.remove('active');
            const parent4 = parent3.parentElement;
            if (parent4) {
              parent4.classList.remove('active');
              const parent5 = parent4.parentElement;
              if (parent5) {
                parent5.classList.remove('active');
                const menuelement = document.getElementById("topnav-menu-content")
                if (menuelement !== null) {
                  if (menuelement.classList.contains('show'))
                    document
                      .getElementById("topnav-menu-content")
                      .classList.remove("show");
                }
              }
            }
          }
        }
      }
    };

    // activate menu item based on location
    const links = document.getElementsByClassName('side-nav-link-ref');
    let matchingMenuItem = null;
    // tslint:disable-next-line: prefer-for-of
    for (let i = 0; i < links.length; i++) {
      // reset menu
      resetParent(links[i]);
    }
    // tslint:disable-next-line: prefer-for-of
    for (let i = 0; i < links.length; i++) {
      // tslint:disable-next-line: no-string-literal
      if (location.pathname === links[i]['pathname']) {
        matchingMenuItem = links[i];
        break;
      }
    }

    if (matchingMenuItem) {
      const parent = matchingMenuItem.parentElement;
      /**
       * TODO: This is hard coded way of expading/activating parent menu dropdown and working till level 3.
       * We should come up with non hard coded approach
       */
      if (parent) {
        parent.classList.add('active');
        const parent2 = parent.parentElement;
        if (parent2) {
          parent2.classList.add('active');
          const parent3 = parent2.parentElement;
          if (parent3) {
            parent3.classList.add('active');
            const parent4 = parent3.parentElement;
            if (parent4) {
              parent4.classList.add('active');
              const parent5 = parent4.parentElement;
              if (parent5) {
                parent5.classList.add('active');
                const parent6 = parent5.parentElement;
                if (parent6) {
                  parent6.classList.add('active');
                }
              }
            }
          }
        }
      }
    }
  }

  /**
   * on settings button clicked from topbar
   */
  onSettingsButtonClicked() {
    document.body.classList.toggle('right-bar-enabled');
  }

  /**
   * Fullscreen method
   */
  fullscreen() {
    document.body.classList.toggle('fullscreen-enable');
    if (
      !document.fullscreenElement && !this.element.mozFullScreenElement &&
      !this.element.webkitFullscreenElement) {
      if (this.element.requestFullscreen) {
        this.element.requestFullscreen();
      } else if (this.element.mozRequestFullScreen) {
        /* Firefox */
        this.element.mozRequestFullScreen();
      } else if (this.element.webkitRequestFullscreen) {
        /* Chrome, Safari and Opera */
        this.element.webkitRequestFullscreen();
      } else if (this.element.msRequestFullscreen) {
        /* IE/Edge */
        this.element.msRequestFullscreen();
      }
    } else {
      if (this.document.exitFullscreen) {
        this.document.exitFullscreen();
      } else if (this.document.mozCancelFullScreen) {
        /* Firefox */
        this.document.mozCancelFullScreen();
      } else if (this.document.webkitExitFullscreen) {
        /* Chrome, Safari and Opera */
        this.document.webkitExitFullscreen();
      } else if (this.document.msExitFullscreen) {
        /* IE/Edge */
        this.document.msExitFullscreen();
      }
    }
  }

  /**
   * Initialize
   */
  initialize(): void {
    this.menuItems = this.appendMobileLabMenu(this.appendOrderListMenu(this.filterTasksMenuForCustomer(MENU)));
  }

  /**
   * Returns true or false if given menu item has child or not
   * @param item menuItem
   */
  hasItems(item: MenuItem) {
    return item.subItems !== undefined ? item.subItems.length > 0 : false;
  }

  private filterTasksMenuForCustomer(items: MenuItem[]): MenuItem[] {
    if (!this.isCustomerLogin()) {
      return items;
    }

    return (items || [])
      .map((item: MenuItem) => {
        const subItems = Array.isArray(item?.subItems)
          ? this.filterTasksMenuForCustomer(item.subItems)
          : item?.subItems;

        const nextItem = subItems !== item?.subItems
          ? { ...item, subItems }
          : item;

        if (this.isTasksMenuItem(nextItem)) {
          return null;
        }

        if (Array.isArray(nextItem?.subItems) && nextItem.subItems.length === 0 && !nextItem?.link) {
          return null;
        }

        return nextItem;
      })
      .filter((item): item is MenuItem => !!item);
  }

  private isTasksMenuItem(item: MenuItem): boolean {
    const label = String(item?.label || '').toLowerCase();
    const link = String(item?.link || '').toLowerCase();

    return label.includes('tasks') || link.startsWith('/tasks');
  }

  private isCustomerLogin(): boolean {
    try {
      const roleNames = JSON.parse(localStorage.getItem('roleNames') || '[]');
      if ((roleNames || []).some((name: string) => String(name || '').toLowerCase().includes('customer'))) {
        return true;
      }

      const userData = JSON.parse(localStorage.getItem('user_data') || '{}');
      const roleId = Number(userData?.user?.roleId ?? userData?.roleId ?? 0);
      const departmentId = Number(userData?.user?.departmentId ?? userData?.departmentId ?? 0);
      return roleId === 2 || departmentId === 2;
    } catch {
      return false;
    }
  }

  private appendMobileLabMenu(items: MenuItem[]): MenuItem[] {
    if (!this.canAccessMobileLab() || this.hasMenuLink(items, '/orders/mobile-lab')) {
      return items;
    }

    const menuItem: MenuItem = {
      id: 99991,
      label: 'Mobile Lab',
      icon: 'bx-devices',
      link: '/orders/mobile-lab'
    };

    const nextItems = [...(items || [])];
    const ordersParent = nextItems.find((item: MenuItem) =>
      Array.isArray(item?.subItems) && item.subItems.some((child: MenuItem) => String(child?.link || '').startsWith('/orders'))
    );

    if (ordersParent) {
      ordersParent.subItems = [...(ordersParent.subItems || []), menuItem];
      return nextItems;
    }

    return [...nextItems, menuItem];
  }

  private appendOrderListMenu(items: MenuItem[]): MenuItem[] {
    if (this.hasMenuLink(items, '/orders')) {
      return items;
    }

    const menuItem: MenuItem = {
      id: 99990,
      label: 'Order List',
      icon: 'bx-list-ul',
      link: '/orders'
    };

    const nextItems = [...(items || [])];
    const ordersParent = nextItems.find((item: MenuItem) =>
      Array.isArray(item?.subItems) && item.subItems.some((child: MenuItem) => String(child?.link || '').startsWith('/orders'))
    );

    if (ordersParent) {
      ordersParent.subItems = [menuItem, ...(ordersParent.subItems || [])];
      return nextItems;
    }

    return [...nextItems, menuItem];
  }

  private hasMenuLink(items: MenuItem[], link: string): boolean {
    return (items || []).some((item: MenuItem) =>
      item?.link === link || this.hasMenuLink(item?.subItems || [], link)
    );
  }

  private canAccessMobileLab(): boolean {
    try {
      const roleNames = JSON.parse(localStorage.getItem('roleNames') || '[]');
      const normalizedRoleNames = (Array.isArray(roleNames) ? roleNames : [])
        .map((name: string) => String(name || '').trim().toLowerCase());

      if (normalizedRoleNames.some((name: string) => name.includes('admin'))) {
        return true;
      }

      const userData = JSON.parse(localStorage.getItem('user_data') || '{}');
      const roleId = Number(userData?.user?.roleId ?? userData?.roleId ?? 0);
      const departmentId = Number(userData?.user?.departmentId ?? userData?.departmentId ?? 0);
      if (roleId === 1 || departmentId === 1) {
        return true;
      }

      const departmentName = String(
        userData?.user?.departmentName
        ?? userData?.departmentName
        ?? userData?.department?.name
        ?? ''
      ).trim().toLowerCase();

      return normalizedRoleNames.some((name: string) =>
        name.includes('qc')
        || name.includes('back office')
        || name.includes('backoffice')
        || name.includes('mobile lab')
        || name.includes('mobilelab')
        || name.includes('vendor lab')
        || name.includes('vendorlab')
        || name.includes('vendor')
      ) || departmentName.includes('qc')
        || departmentName.includes('back office')
        || departmentName.includes('backoffice')
        || departmentName.includes('mobile lab')
        || departmentName.includes('mobilelab')
        || departmentName.includes('vendor lab')
        || departmentName.includes('vendorlab')
        || departmentName.includes('vendor');
    } catch {
      return false;
    }
  }

}
